"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./InfoLozenge.scss");

var _assets_iconPigRed = _interopRequireDefault(require("../../assets/images/Rebrand/16976-assets_icon-pig-red.svg"));

var _assets_iconMapRed = _interopRequireDefault(require("../../assets/images/Rebrand/16976-assets_icon-map-red.svg"));

var _assets_iconTyreRed = _interopRequireDefault(require("../../assets/images/Rebrand/16976-assets_icon-tyre-red.svg"));

var _aos = _interopRequireDefault(require("aos"));

require("aos/dist/aos.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var InfoLozenge = function InfoLozenge() {
  (0, _react.useEffect)(function () {
    _aos.default.init({
      duration: 1000
    });
  }, []);
  return _react.default.createElement("div", {
    className: "infoLozenge"
  }, _react.default.createElement("div", {
    className: "lozengeItem",
    "data-aos": "fade-right",
    "data-aos-easing": "ease-out-back",
    "data-aos-duration": "1000",
    "data-aos-delay": "0"
  }, _react.default.createElement("h3", {
    className: "lozengeTextH3"
  }, _react.default.createElement("img", {
    className: "lozengeImg",
    src: _assets_iconTyreRed.default,
    alt: "tyre icon"
  }), "\xA0Get the tyres\xA0", _react.default.createElement("span", null, "you"), "\xA0need")), _react.default.createElement("div", {
    className: "lozengeItem",
    "data-aos": "fade-right",
    "data-aos-easing": "ease-out-back",
    "data-aos-duration": "1000",
    "data-aos-delay": "100"
  }, _react.default.createElement("h3", {
    className: "lozengeTextH3 fit flex itemsCenter justifyCenter"
  }, _react.default.createElement("img", {
    className: "lozengeImg",
    src: _assets_iconMapRed.default,
    alt: "map icon"
  }), "\xA0Fitted where\xA0", _react.default.createElement("span", null, "you"), "\xA0want")), _react.default.createElement("div", {
    className: "lozengeItem",
    "data-aos": "fade-right",
    "data-aos-easing": "ease-out-back",
    "data-aos-duration": "1000",
    "data-aos-delay": "200"
  }, _react.default.createElement("h3", {
    className: "lozengeTextH3 fit flex itemsCenter justifyCenter"
  }, _react.default.createElement("img", {
    className: "lozengeImg",
    src: _assets_iconPigRed.default,
    alt: "piggy bank icon"
  }), "\xA0For the price\xA0", _react.default.createElement("span", null, "you"), "\xA0love")));
};

var _default = InfoLozenge;
exports.default = _default;